
// Category
export const GET_CATEGORY_SUCCESS = 'GET_CATEGORY_SUCCESS';
export const GET_CATEGORY_FAIL = 'GET_CATEGORY_FAIL';
// Banner
export const GET_BANNER_SUCCESS = 'GET_BANNER_SUCCESS';
export const GET_BANNER_FAIL = 'GET_BANNER_FAIL';

// product offer
export const GET_PRODUCT_OFFER_SUCCESS = 'GET_PRODUCT_OFFER_SUCCESS';
export const GET_PRODUCT_OFFER_FAIL = 'GET_PRODUCT_OFFER_FAIL';

// product new
export const GET_PRODUCT_NEW_SUCCESS = 'GET_PRODUCT_NEW_SUCCESS';
export const GET_PRODUCT_NEW_FAIL = 'GET_PRODUCT_NEW_FAIL';

// product
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAIL = 'GET_PRODUCT_FAIL';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAIL = 'GET_PRODUCTS_FAIL';
export const PETITION_PROD = 'PETITION_PROD';
export const CLEAR_DATA = 'CLEAR_DATA';
export const GET_PRODUCTS_RELATIONS_SUCCESS = 'GET_PRODUCTS_RELATIONS_SUCCESS';
export const SET_SEARCH_SUCCESS = 'SET_SEARCH_SUCCESS';
export const CLEAR_SEARCH_SUCCESS = 'CLEAR_SEARCH_SUCCESS';
export const GET_SEARCH_PRODUCTS_SUCCESS = 'GET_SEARCH_PRODUCTS_SUCCESS';
export const PETITION_PROD_SEARCH = 'PETITION_PROD_SEARCH';
export const CLEAR_PRODUCT = 'CLEAR_PRODUCT';

export const GET_BEST_SELLING_PRODUCTS_SUCCESS  = 'GET_BEST_SELLING_PRODUCTS_SUCCESS';
export const PETITION_PROD_BEST_SELLING         = 'PETITION_PROD_BEST_SELLING';
export const GET_PRODUCT_BEST_SELLINGS_SUCCESS  = 'GET_PRODUCT_BEST_SELLINGS_SUCCESS';
export const GET_PRODUCT_BEST_SELLINGS_FAIL     = 'GET_PRODUCT_BEST_SELLINGS_FAIL';

//catalog
export const GET_OFFER_PRODUCTS_SUCCESS = 'GET_OFFER_PRODUCTS_SUCCESS';
export const PETITION_PROD_OFFER = 'PETITION_PROD_OFFER';
export const GET_NEW_PRODUCTS_SUCCESS = 'GET_NEW_PRODUCTS_SUCCESS';
export const PETITION_PROD_NEW = 'PETITION_PROD_NEW';
export const GET_FAVORITE_PRODUCTS = 'GET_FAVORITE_PRODUCTS';
export const PETITION_PROD_FAVORITE = 'PETITION_PROD_FAVORITE';

// Home
export const GET_HOME_STORE_SUCCESS = 'GET_HOME_STORE_SUCCESS';
export const GET_HOME_SUCCESS = 'GET_HOME_SUCCESS';
export const GET_HOME_FAIL = 'GET_HOME_FAIL';

// Store
export const GET_STORE_SUCCESS = 'GET_STORE_SUCCESS';
export const GET_STORE_FILTER_SUCCESS = 'GET_STORE_FILTER_SUCCESS';



// Pet
export const GET_PETS_SUCCESS = 'GET_PETS_SUCCESS';
export const GET_PETS_FAIL = 'GET_PETS_FAIL';
export const GET_PETS_RELATED_SUCCESS = 'GET_PETS_RELATED_SUCCESS';
export const GET_PETS_RELATED_FAIL = 'GET_PETS_RELATED_FAIL';
export const GET_PET_SUCCESS = 'GET_PET_SUCCESS';
export const GET_PET_FAIL = 'GET_PET_FAIL';
export const PETITION_PET = 'PETITION_PET';



// Filter
export const GET_FILTER_SUCCESS = 'GET_FILTER_SUCCESS';
export const GET_FILTER_FAIL = 'GET_FILTER_FAIL';


//auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';


export const SEND_CODE_MAIL = 'SEND_CODE_MAIL';
export const VERIFY_CODE_MAIL = 'VERIFY_CODE_MAIL';
export const REGISTER_USER = 'REGISTER_USER';
export const LOGOUT = 'LOGOUT';
export const USER_SUCCESS = 'USER_SUCCESS';

//carrito
export const CLEAR_CART = 'CLEAR_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const INC_TO_CART = 'INC_TO_CART';
export const DEC_TO_CART = 'DEC_TO_CART';
export const REMOVE_TO_CART = 'REMOVE_TO_CART';
export const UPDATE_TO_CART = 'UPDATE_TO_CART';
export const SET_STORE = 'SET_STORE';
export const REFRESH_QUANTITY = 'REFRESH_QUANTITY';

//ubicacion
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS';
export const GET_LOCATION_FAIL = 'GET_LOCATION_FAIL';
export const GET_LOCATION_CURRENT = 'GET_LOCATION_CURRENT';
export const UPDATE_LOCATION_SUCCESS = 'UPDATE_LOCATION_SUCCESS';
export const UPDATE_LOCATION_FAIL = 'UPDATE_LOCATION_FAIL';

//PAYMENT METHOD
export const GET_PAYMENT_METHOD_SUCCESS = 'GET_PAYMENT_METHOD_SUCCESS';
export const GET_PAYMENT_METHOD_FAIL = 'GET_PAYMENT_METHOD_FAIL';
export const GET_DELIVERY_METHOD_SUCCESS = 'GET_DELIVERY_METHOD_SUCCESS';
export const GET_DELIVERY_METHOD_FAIL = 'GET_DELIVERY_METHOD_FAIL';
export const GET_USER_INVOICE_SUCCESS = 'GET_USER_INVOICE_SUCCESS';
export const GET_USER_INVOICE_FAIL = 'GET_USER_INVOICE_FAIL';
export const PETITION_INVOICES = 'PETITION_INVOICES';
export const GET_INVOICE_CURRENT = 'GET_INVOICE_CURRENT';
export const UPDATE_DATA_PAYMENT = 'UPDATE_DATA_PAYMENT';

//SALE
export const POST_SALE_SUCCESS = 'POST_SALE_SUCCESS';
export const POST_SALE_FAIL = 'POST_SALE_FAIL';
export const CLEAN_PURCHASE = 'CLEAN_PURCHASE';


//USER
export const GET_PURCHASES_SUCCESS  = 'GET_PURCHASES_SUCCESS';
export const GET_PURCHASES_REQUEST_SUCCESS= 'GET_PURCHASES_REQUEST_SUCCESS';
export const GET_PURCHASES_FAIL     = 'GET_PURCHASES_FAIL';
export const UPDATE_USER_SUCCESS    = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL       = 'UPDATE_USER_FAIL';
export const UPDATE_FAVORITE_STATUS = "UPDATE_FAVORITE_STATUS";
export const GET_PURCHASE_SUCCESS   = "GET_PURCHASE_SUCCESS";
export const GET_PURCHASE_FAIL      = "GET_PURCHASE_FAIL";
export const PETITION_GET_PURCHASE  = "PETITION_GET_PURCHASE";
export const GET_ADDRESSES_SUCCESS  = 'GET_ADDRESSES_SUCCESS';
export const GET_ADDRESSES_FAIL     = 'GET_ADDRESSES_FAIL';
export const PETITION_ADDRESSES     = 'PETITION_ADDRESSES';

